/** Every Vietnamese string the API's English codes map to (rule 5: labels only in the UI). */
import { adsEnabled } from "./ads/enabled";

/** How to get tokens again: an ad (only when the page offers them) or the free refill at 0h. */
function moreTokens(allowance: number = FREE_DAILY): string {
  return adsEnabled() ? `Xem quảng cáo để nhận thêm, hoặc chờ 0h để nhận lại ${allowance} token miễn phí.`
    : `Chờ 0h để nhận lại ${allowance} token miễn phí.`;
}

const ERRORS: Record<string, string> = {
  not_admin: "Tài khoản này không có quyền quản lý.",
  not_an_edit_model: "Chỉ dùng được model chỉnh sửa ảnh (gửi ảnh vào, nhận ảnh đã sửa), không dùng model tạo ảnh từ chữ.",
  job_not_done: "Chỉ đánh giá được ảnh đã xử lý xong.",
  topup_below_zero: "Không trừ được: số token nạp sẽ thành số âm.",
  user_not_found: "Không tìm thấy tài khoản.",
  account_locked: "Tài khoản tạm khoá vì gửi nhiều ảnh không phù hợp. Vui lòng thử lại sau.",
  too_many_jobs: "Bạn gửi ảnh quá nhanh. Đợi 1 phút rồi thử lại.",
  turnstile_failed: "Không xác minh được trình duyệt. Tải lại trang rồi thử lại.",
  image_too_large: "Ảnh quá lớn (tối đa 15 MB).",
  image_too_many_pixels: "Ảnh có độ phân giải quá lớn.",
  image_unsupported: "Chỉ nhận ảnh JPG, PNG hoặc WebP.",
  image_corrupt: "Không đọc được ảnh. Hãy chọn ảnh khác.",
  invalid_settings: "Tuỳ chọn không hợp lệ. Tải lại trang rồi thử lại.",
  bad_idempotency_key: "Yêu cầu không hợp lệ. Tải lại trang rồi thử lại.",
  not_signed_in: "Vui lòng đăng nhập để tiếp tục.",
  bad_google_token: "Đăng nhập Google không thành công. Thử lại.",
  google_sign_in_disabled: "Máy chủ chưa bật đăng nhập Google.",
  csrf: "Phiên đăng nhập đã hết hạn. Tải lại trang.",
  job_not_found: "Không tìm thấy ảnh này (có thể đã bị xoá).",
  job_running: "Ảnh đang được xử lý, chưa xoá được.",
  file_not_found: "Ảnh đã bị xoá hoặc đường dẫn đã hết hạn.",
  ad_wallet_full: "Ví token quảng cáo đã đầy.",
  ad_daily_limit: "Hôm nay bạn đã xem đủ số quảng cáo được thưởng.",
  ad_ip_limit: "Mạng của bạn đã nhận đủ phần thưởng hôm nay.",
  ad_too_many_pending: "Bạn đang mở nhiều quảng cáo cùng lúc. Đợi vài phút rồi thử lại.",
  ad_too_fast: "Hãy xem hết quảng cáo để nhận token.",
  ad_expired: "Phiên quảng cáo đã hết hạn. Thử lại.",
  ad_bad_nonce: "Phiên quảng cáo không hợp lệ. Thử lại.",
  ad_not_found: "Phiên quảng cáo không hợp lệ. Thử lại.",
  ad_unavailable: "Hiện chưa có quảng cáo phù hợp. Thử lại sau ít phút.",
  network: "Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.",
  server_error: "Máy chủ đang gặp sự cố. Thử lại sau.",
  unsupported_photo: "Trình duyệt không đọc được ảnh này. Hãy chọn ảnh JPG hoặc PNG.",
  // premium models (section 5, Plus / Gold)
  model_not_allowed: "Model này chỉ dành cho thành viên Plus / Gold.",
  unknown_model: "Model này hiện không còn. Chọn lại ở mục 5.",
  model_unavailable: "Model này tạm thời không dùng được. Chọn model khác hoặc Tiêu chuẩn ở mục 5.",
  model_daily_cap: "Hôm nay bạn đã dùng hết số lần cho model này. Chọn model khác hoặc thử lại ngày mai.",
  insufficient_topup: "Model này chỉ trừ token nạp và bạn không đủ token nạp.",
  // /admin › AI cao cấp
  provider_not_found: "Không tìm thấy nhà cung cấp.",
  model_fields_missing: "Model mới cần đủ: nhà cung cấp, mã model, tên, chi phí ước tính, giá token.",
  setting_out_of_range: "Giá trị nằm ngoài khoảng cho phép.",
  secret_key_missing: "Máy chủ chưa có IDSERVER_SECRET_KEY nên không lưu được khoá API.",
  // /admin › Liên hệ
  invalid_zalo_phone: "Số Zalo không hợp lệ: nhập số di động 10 chữ số, ví dụ 0912 345 678 hoặc +84 912 345 678.",
  invalid_messenger: "Messenger không hợp lệ: nhập tên trang Facebook (ví dụ dtaa.studio) hoặc link m.me / facebook.com của trang.",
  // v4 "Chỉnh ảnh"
  invalid_recipe: "Thiết lập chỉnh ảnh không hợp lệ. Tải lại trang rồi thử lại.",
  source_not_found: "Ảnh đang chỉnh đã hết hạn trên máy chủ. Chọn lại ảnh.",
  preview_not_found: "Bản xem trước đã hết hạn.",
  too_many_previews: "Bạn đang chỉnh quá nhanh, bản xem trước sẽ cập nhật sau vài giây.",
  too_many_sources: "Bạn đã mở quá nhiều ảnh trong một giờ. Thử lại sau.",
  timeout: "Máy xử lý đang bận, bản xem trước chưa cập nhật.",
  nsfw: "Ảnh không phù hợp nên không được xử lý.",
  invalid_image: "Không đọc được ảnh.",
  error: "Máy xử lý gặp lỗi khi xem trước.",
  // /admin › Tài sản
  manifest_bad: "Manifest không hợp lệ: xem chi tiết bên dưới.",
  asset_kind_unknown: "Loại tài sản chưa hỗ trợ.",
  preset_needs_cube: "Preset cần file preset.cube.",
  cube_unreadable: "Không đọc được file .cube.",
  cube_size: "Preset phải là LUT 33³.",
  cube_1d_not_supported: "Không nhận LUT 1D.",
  thumb_bad: "Ảnh mẫu phải là JPEG, cạnh dài ≤ 1024 px.",
  asset_version: "Số phiên bản không đúng (để trống để máy chủ tự đánh số).",
  asset_status: "Không đổi được trạng thái này.",
  asset_not_found: "Không tìm thấy tài sản.",
  asset_file_name: "Tên file không được nhận (preset.cube, thumb.jpg).",
  asset_file_too_large: "File quá lớn.",
  // v4 GĐ5 "Hàng loạt & in", "Logo tiệm"
  studio_only: "Chỉ tài khoản tiệm ảnh mới đóng logo được. Liên hệ DTAA để đăng ký tiệm ảnh.",
  batch_not_found: "Không tìm thấy lô ảnh này (có thể đã bị xoá).",
  batch_too_large: "Mỗi lần xử lý hàng loạt tối đa 50 ảnh.",
  variants_no_ai: "Render cả 4 mức chưa làm được các bước AI (ủi đồ, thay áo, miệng cười): tắt bước AI rồi render, sau đó xuất mức đã chọn kèm bước AI.",
  batch_ai_not_supported: "Hàng loạt chưa làm được các bước AI (ủi đồ, thay áo, miệng cười): tắt bước AI, hoặc xuất từng ảnh một.",
  too_many_batches: "Bạn đã xử lý nhiều lô ảnh trong một giờ. Thử lại sau.",
  batch_not_open: "Lô ảnh đã bắt đầu xử lý, không thêm ảnh được nữa.",
  batch_expired: "Lô ảnh chờ quá lâu nên đã bị huỷ (chưa trừ token). Bấm xuất lại.",
  batch_index: "Ảnh không thuộc lô này.",
  batch_empty: "Lô ảnh chưa có ảnh nào được tải lên.",
  batch_not_started: "Lô ảnh chưa được xử lý.",
  batch_nothing_done: "Chưa có ảnh nào xử lý xong để xếp tờ in.",
  logo_needs_png: "Chọn file logo PNG.",
  logo_not_png: "Logo phải là file PNG có nền trong suốt.",
  logo_no_alpha: "Logo cần nền trong suốt (PNG có kênh alpha).",
  logo_empty: "Logo trong suốt hoàn toàn, không có gì để đóng.",
  logo_too_small: "Logo quá nhỏ (cạnh dài tối thiểu 32 px).",
  logo_too_big: "Logo quá lớn (tối đa 4000 px, 30 MB).",
  logo_unreadable: "Không đọc được file logo.",
  logo_not_found: "Không tìm thấy logo này.",
  too_many_logos: "Đã đủ số logo tối đa. Xoá bớt logo cũ rồi tải lên.",
  // GĐ4: chữ, khung, overlay
  tier_required: "Ảnh có mục dành cho gói Plus / Gold (biểu tượng khoá) hoặc xuất PSD: nâng gói hoặc bỏ mục đó rồi xuất lại. Bạn chưa bị trừ token.",
  font_needs_file: "Font cần đúng một file font.ttf hoặc font.otf.",
  font_needs_license: "Font cần file giấy phép (ofl.txt / license.txt) đúng loại giấy phép ghi trong manifest.",
  font_unreadable: "Không đọc được file font (chỉ nhận TTF / OTF, một kiểu chữ mỗi file).",
  font_restricted: "Font cấm nhúng (fsType restricted): không dùng được.",
  font_no_vietnamese: "Font thiếu chữ tiếng Việt có dấu.",
  template_needs_files: "Mẫu chữ cần template.psd và thumb.jpg.",
  template_psd_size: "Kích thước PSD khác layout trong manifest.",
  template_psd_layers: "PSD thiếu lớp chữ đặt tên theo trường (ten, ngay, tieu_de, phu_de).",
  psd_unreadable: "Không đọc được file PSD.",
  frame_needs_png: "Khung cần file frame-<tỉ lệ>.png (2x3, 3x2, 3x4, 4x3, 4x5, 5x4, 1x1, 16x9, 9x16).",
  frame_not_rgba: "Khung phải là PNG có kênh alpha (RGBA).",
  frame_size: "Kích thước khung không đúng tỉ lệ trong tên file (cạnh dài ≥ 512 px).",
  frame_centre_opaque: "Giữa khung phải trong suốt.",
  overlay_needs_file: "Overlay cần đúng một file overlay.png (RGBA) hoặc overlay.jpg (nền đen).",
  overlay_bad: "Overlay không hợp lệ: PNG RGBA, hoặc JPEG nền đen với chế độ screen; cạnh dài ≥ 512 px.",
  asset_image_unreadable: "Không đọc được ảnh tải lên.",
  // Chỉnh ảnh GĐ3
  model_without_ai: "Chỉ chọn model cao cấp khi có bước AI (ủi đồ, thay áo, miệng cười).",
  photo_bad: "Ảnh phải là JPEG sRGB, cạnh dài 1024–12000 px.",
  background_needs_jpg: "Phông nền cần file background.jpg.",
  sky_needs_jpg: "Bầu trời cần file sky.jpg.",
  // v4: no render machine serves the AI queue (server availability.py; refused before anything is charged)
  queue_unavailable: "AI tạm nghỉ, chưa nhận ảnh AI. Bạn chưa bị trừ token; thử lại sau ít phút.",
};

/** The contact buttons at the bottom right (ContactButtons.tsx). */
export const CONTACT = {
  label: "Liên hệ DTAA",
  zalo: "Chat Zalo với DTAA",
  messenger: "Nhắn Messenger cho DTAA",
};

export function errorMessage(code: string): string {
  if (code === "insufficient_coins") return `Bạn đã hết token. ${moreTokens()}`;
  return ERRORS[code] ?? "Đã có lỗi xảy ra. Thử lại sau.";
}

const REJECTS: Record<string, string> = {
  nsfw: "Ảnh không phù hợp nên không được xử lý.",
  no_face: "Không tìm thấy khuôn mặt. Hãy chụp chính diện, rõ mặt, đủ sáng.",
  invalid_image: "Không đọc được ảnh.",
  error: "Máy xử lý gặp lỗi.",
  lease_expired: "Xử lý quá lâu nên bị huỷ.",
  queue_timeout: "Máy xử lý đang quá bận.",
  user_cancelled: "Bạn đã huỷ yêu cầu.",
  ai_failed: "Chỉnh sửa nâng cao chưa thực hiện được với ảnh này. Hãy thử ảnh khác hoặc chọn ít chỉnh sửa hơn.",
  sharpen_failed: "Chưa kích nét được ảnh này mà vẫn giữ nguyên khuôn mặt. Hãy thử lại sau hoặc dùng ảnh khác.",
};

export function rejectMessage(reason: string | null): string {
  return `${REJECTS[reason ?? ""] ?? "Ảnh không xử lý được."} Token đã được hoàn lại.`;
}

const WARNINGS: Record<string, string | null> = {
  geometry_edit_not_for_documents: "Có chỉnh hình dạng khuôn mặt: KHÔNG dùng ảnh này cho hộ chiếu, CCCD, visa.",
  background_not_in_spec: "Màu nền không đúng quy cách đã chọn.",
  sheet_not_generated: null, // the web lays out its own print sheet now
  nsfw_review: null, // internal flag for moderators
};

/**
 * Free text from the pipeline (idphoto/core, Vietnamese but written for operators: pixel sizes, model names, scores).
 * The first matching rule wins: a sentence for the user, or null to leave it out of the page (it stays in the job).
 */
const FREE_TEXT: [RegExp, string | null][] = [
  [/^Ảnh gốc nhỏ so với kích thước in|^Ảnh bị phóng to/,
   "Ảnh gốc hơi nhỏ nên ảnh in có thể kém nét. Nên dùng ảnh chụp lớn, rõ hơn."],
  [/^Ảnh gốc thiếu khoảng trống/,
   "Ảnh gốc chụp hơi sát nên khung được dời hoặc nới thêm nền. Kiểm tra mép ảnh; lần sau nên chụp lùi ra một chút."],
  [/^Đầu nghiêng/, "Đầu nghiêng nhiều nên chưa xoay thẳng hết được. Nên chụp lại, giữ đầu thẳng."],
  [/^Phát hiện \d+ khuôn mặt/, "Ảnh có nhiều khuôn mặt; đã chọn người lớn nhất ở giữa."],
  [/^Không phát hiện khuôn mặt/, "Không thấy rõ khuôn mặt trong ảnh."],
  [/^Tăng nét.*bỏ qua/, "Không tăng nét vì sẽ làm khuôn mặt khác đi; ảnh giữ nguyên."],
  [/^Tăng nét/, null], // done as asked: nothing to say
  [/^Làm đẹp làm khuôn mặt khác đi quá mức/, "Một số mục làm đẹp đã tự tắt vì làm khuôn mặt khác đi quá nhiều."],
  [/^Làm đẹp có mục thay đổi hình học/, null], // same as geometry_edit_not_for_documents
  [/^Bỏ qua làm đẹp/, "Không áp dụng được làm đẹp cho ảnh này."],
  [/^Ánh sáng đang Tắt/, "Ánh sáng đang tắt nên bộ lọc ánh sáng không được áp dụng."],
  [/tách nền|Tách nền|mask nền/, "Nền chưa tách được hoàn chỉnh: kiểm tra viền tóc và màu nền."],
  // anything else that carries numbers, model or hardware names is for the operator's log, not for this page
  [/\d|model|GPU|CUDA|ONNX|Haar|GrabCut|YuNet|SFace|ArcFace|ESRGAN|MediaPipe|landmark|điểm mốc/i, null],
];

/** Warning codes and pipeline notes as short sentences for the user, without technical figures; duplicates dropped. */
export function warningMessages(warnings: string[]): string[] {
  const out = warnings.flatMap((w) => {
    if (w in WARNINGS) return WARNINGS[w] ? [WARNINGS[w] as string] : [];
    const rule = FREE_TEXT.find(([re]) => re.test(w));
    if (rule) return rule[1] ? [rule[1]] : [];
    return [w];
  });
  return [...new Set(out)];
}

/** Each QC check by name (core/qc.py codes); the pipeline's own sentence carries figures and stays in the job data. */
export const QC_ITEM_NAMES: Record<string, string> = {
  SIZE: "Kích thước ảnh", FACE: "Khuôn mặt", FACE_COUNT: "Một người trong ảnh", LANDMARKS: "Nhận diện nét mặt",
  IDENTITY: "Giữ đúng khuôn mặt", HEAD_HEIGHT: "Cỡ đầu", EYE_LINE: "Vị trí mắt", CROWN_MARGIN: "Khoảng trống trên đầu",
  CENTER: "Mặt ở giữa", ROLL: "Đầu thẳng", YAW: "Mặt nhìn thẳng", PITCH: "Không ngẩng, không cúi",
  EXPOSURE: "Độ sáng mặt", CLIPPING: "Không cháy sáng", SIDE_LIGHT: "Sáng đều hai bên mặt", BG_UNIFORM: "Nền đều màu",
  BG_COLOR: "Màu nền", MATTE: "Tách nền", RESOLUTION: "Độ nét khi in", PADDED: "Mép ảnh",
};

/** What to look at when a check is not passed (no figures). */
export const QC_ITEM_HINTS: Record<string, string> = {
  SIZE: "kích thước chưa đúng quy cách", FACE: "không thấy khuôn mặt", FACE_COUNT: "có hơn một người",
  LANDMARKS: "chưa nhận diện đủ nét mặt", IDENTITY: "khuôn mặt bị thay đổi nhiều",
  HEAD_HEIGHT: "đầu quá to hoặc quá nhỏ so với khung", EYE_LINE: "mắt chưa ở đúng độ cao",
  CROWN_MARGIN: "đỉnh đầu quá sát mép trên", CENTER: "mặt lệch khỏi giữa", ROLL: "đầu hơi nghiêng",
  YAW: "mặt quay sang một bên", PITCH: "đầu hơi ngẩng hoặc cúi", EXPOSURE: "mặt quá tối hoặc quá sáng",
  CLIPPING: "có vùng cháy sáng trên mặt", SIDE_LIGHT: "hai bên mặt sáng không đều", BG_UNIFORM: "nền chưa đều màu",
  BG_COLOR: "màu nền chưa đúng quy cách", MATTE: "kiểm tra viền tóc", RESOLUTION: "ảnh gốc nhỏ, có thể mờ khi in",
  PADDED: "ảnh gốc chụp sát, nền được nới thêm",
};

export const STATUS_LABELS: Record<string, string> = {
  queued: "Đang chờ máy xử lý",
  running: "Đang xử lý",
  done: "Xong",
  rejected: "Không xử lý được",
  failed: "Lỗi",
  cancelled: "Đã huỷ",
};

export const TIER_LABELS: Record<string, string> = { normal: "Thường", test: "Thử nghiệm", plus: "Plus", gold: "Gold" };
export const PLAN_LABELS: Record<string, string> = {
  week: "1 tuần", month: "1 tháng", year: "1 năm", days: "Số ngày tuỳ chọn", forever: "Không thời hạn",
};
export const WALLET_LABELS: Record<string, string> = { daily: "Free hôm nay", earned: "Quảng cáo", topup: "Nạp" };
export const LEDGER_LABELS: Record<string, string> = {
  daily_reset: "Nạp lại 0h", ad_reward: "Xem quảng cáo", job_debit: "Render", job_refund: "Hoàn token",
  admin_adjust: "Quản lý nạp", tier_change: "Đổi loại tài khoản",
  referral_reward: "Giới thiệu bạn bè",
};
export const RATING_LABELS = ["", "Rất tệ", "Chưa tốt", "Tạm được", "Tốt", "Rất tốt"];

/** "21/11/2026" (local date). */
export function shortDate(iso: string): string {
  const d = new Date(iso);
  const two = (n: number) => String(n).padStart(2, "0");
  return `${two(d.getDate())}/${two(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** "Gói Plus · đến 21/11/2026" / "Tài khoản thử nghiệm" / null for a normal account. */
export function tierLine(tier: string | undefined, until: string | null | undefined): string | null {
  if (!tier || tier === "normal") return null;
  if (tier === "test") return "Tài khoản thử nghiệm";
  return `Gói ${TIER_LABELS[tier] ?? tier}${until ? ` · đến ${shortDate(until)}` : ""}`;
}

export const QC_LABELS: Record<string, string> = { pass: "Đạt chuẩn", warn: "Cần xem lại", fail: "Không đạt" };
export const QC_ITEM_LABELS: Record<string, string> = { pass: "Đạt", warn: "Lưu ý", fail: "Lỗi" };

/** Free coins every day at 0h Vietnam time (server `daily_free`; the API does not publish it to guests). */
export const FREE_DAILY = 5;

/** Static pages `public/*.html`, served without the extension (nginx, `vite dev`); Google OAuth branding points here. */
export const LEGAL = { privacy: "/privacy-policy", terms: "/term-of-service" } as const;

/** The render button and what it tells about coins (the user asked to see the charge ON the button). */
export const RENDER = {
  label: (cost: number) => (cost ? `Xử lý ảnh này · −${cost} token` : "Xử lý ảnh này · miễn phí"),
  sending: "Đang gửi ảnh…",
  guest: `Cần đăng nhập · mỗi ngày ${FREE_DAILY} token miễn phí`,
  checking: "Đang kiểm tra ví token…",
  after: (left: number) => `Còn ${left} token sau khi render`,
  short: (total: number) => `Bạn còn ${total} token · ${adsEnabled() ? "xem quảng cáo để nhận thêm" : "nạp lại lúc 0h"}`,
  charged: (cost: number, total: number) => `Đã trừ ${cost} token · còn ${total} token`,
  free: "Tài khoản thử nghiệm · không trừ token",
  sentFree: "Đã gửi ảnh · tài khoản thử nghiệm không bị trừ token",
  refunded: (cost: number, total: number) => `Đã hoàn ${cost} token · còn ${total} token`,
  replayed: "Ảnh này đã được gửi trước đó, không trừ thêm token.",
  needPhoto: "Chọn ảnh ở mục 1.",
  needConsent: "Đánh dấu ô đồng ý xử lý ảnh ở mục 1.",
  needAiTask: "Chọn ít nhất một chỉnh sửa ở mục 5, hoặc tắt chỉnh sửa nâng cao.",
  noCoins: (cost: number, total: number, allowance?: number) =>
    `Không đủ token: cần ${cost}, bạn còn ${total}. ${moreTokens(allowance)}`,
  // premium models: paid from the top-up wallet only (plan 2026-10-21, choice A)
  noTopup: (cost: number, topup: number) => `Model này trừ token nạp: cần ${cost}, bạn còn ${topup}.`,
  afterTopup: (left: number) => `Còn ${left} token nạp sau khi render`,
  shortTopup: (topup: number) => `Bạn còn ${topup} token nạp · model cao cấp chỉ trừ token nạp`,
  needProviderConsent: (provider: string) => `Đánh dấu ô đồng ý gửi ảnh tới ${provider} ở mục 5.`,
  modelUnavailable: "Model đã chọn tạm thời không dùng được. Chọn model khác ở mục 5.",
};

/** "5. Chỉnh sửa nâng cao" for Plus / Gold: the model choice (names and prices only, nothing technical). */
export const PREMIUM = {
  standard: (cost: number) => `Tiêu chuẩn (${cost ? `${cost} token` : "miễn phí"})`,
  option: (m: { label: string; price_tokens: number; available: boolean }) =>
    `${m.label} · ${m.price_tokens ? `−${m.price_tokens} token` : "miễn phí"}${m.available ? "" : " · Tạm thời không dùng được"}`,
  topupOnly: "Model cao cấp chỉ trừ token nạp, không dùng token free hay token quảng cáo.",
  consent: (provider: string) =>
    `Tôi đồng ý gửi ảnh tới ${provider} (máy chủ ở nước ngoài) để chỉnh sửa; ảnh không dùng để huấn luyện AI.`,
  time: "Mỗi lần thường mất khoảng 30 giây đến 1 phút.",
};

export const COMPARE_MODE_LABELS: Record<string, string> = {
  side: "Cạnh nhau", slider: "Kéo so sánh", result: "Chỉ kết quả", source: "Chỉ gốc",
};

/** An advanced-edit job delivers two photos: the AI one and the same photo processed without AI. */
export const AI_RESULT = {
  local: "Xử lý thường (không AI)",
  ai: "Kết quả AI",
  slider: "Xử lý thường ◂ ▸ Kết quả AI",
  downloadAi: "Tải ảnh AI (JPG)",
  downloadLocal: "Tải ảnh xử lý thường (JPG)",
  hint: "Ảnh xử lý thường cùng quy cách nhưng không qua AI: tải ảnh bạn ưng ý hơn.",
  sheetFrom: "Ảnh trên tờ in",
};

export const LIGHT_MODE_LABELS: Record<string, string> = { auto: "Tự động", auto_plus: "Tự động + chỉnh", off: "Tắt" };
export const SKIN_MODE_LABELS: Record<string, string> = { off: "Tắt", light: "Nhẹ", medium: "Vừa", custom: "Tuỳ chỉnh" };
/** The desktop "Tự động + chỉnh" sliders (app/ui/adjust_panel.py). */
export const LIGHT_ADJUST_LABELS: Record<string, string> = {
  exposure_ev: "Phơi sáng", shadow_lift: "Mở bóng tối", highlight_recover: "Giảm cháy sáng", contrast: "Tương phản",
  local_contrast: "Tương phản cục bộ", wb_temperature: "Nhiệt độ màu (lạnh ↔ ấm)", sharpen: "Làm nét",
};
export const LIGHT_FILTER_LABELS: Record<string, string> = {
  none: "Không", studio: "Studio sáng đều", bright: "Sáng rõ", warm: "Ấm áp", cool: "Mát lạnh", soft: "Mềm mịn",
  contrast: "Tương phản",
};
export const BEAUTY_LABELS: Record<string, string> = {
  blemish: "Mụn, sẹo, vết thâm", even_tone: "Đều màu, sáng da", under_eye: "Quầng thâm mắt", wrinkle: "Nếp nhăn nhẹ",
  shine: "Bóng dầu", eye_brighten: "Sáng mắt", teeth: "Trắng răng", flyaway: "Tóc con ở viền", blush: "Má hồng",
  brow: "Đậm lông mày", lipstick: "Tô son", hair_colour: "Đổi màu tóc", eye_enlarge: "To mắt (đổi hình học)",
  face_slim: "Thon gọn mặt (đổi hình học)", feature_balance: "Cân đối hai bên (đổi hình học)",
  nose_slim: "Thon mũi (đổi hình học)", mouth_small: "Thu nhỏ miệng (đổi hình học)",
  brow_lift: "Nâng lông mày (đổi hình học)", lip_full: "Môi đầy đặn (đổi hình học)",
};

/** One line under each face-shape item (catalog `geometry_items`); the "not for documents" alert is shared. */
export const GEOMETRY_NOTES: Record<string, string> = {
  eye_enlarge: "Phóng vùng mắt tối đa 10 %.",
  face_slim: "Thu gọn hàm và má dưới.",
  feature_balance: "Làm đều lông mày, mắt, mũi, khoé miệng hai bên.",
  nose_slim: "Thu gọn hai cánh mũi.",
  mouth_small: "Thu gọn hai khoé miệng.",
  brow_lift: "Nâng lông mày lên một chút.",
  lip_full: "Viền môi dày thêm một chút.",
};
export const GEOMETRY_ALERT = "Có mục làm đổi hình dạng khuôn mặt: KHÔNG dùng cho hộ chiếu, CCCD, visa.";

export function label(map: Record<string, string>, key: string): string {
  return map[key] ?? key;
}

/** "Chỉnh tiếp ảnh này": an ID-photo result opened in "Ảnh chuyên nghiệp" (merged page, GĐ2). */
export const CONTINUE = {
  button: "Chỉnh tiếp ảnh này (Ảnh chuyên nghiệp)",
  busy: "Đang mở ảnh…",
  hint: "Thêm chữ, khung, in khổ lớn… Ảnh chỉnh xong không còn nhãn đạt chuẩn ảnh thẻ.",
  failed: "Không mở được ảnh để chỉnh tiếp. Thử lại sau ít phút.",
};

/** The one consent box of the page (both modes; stored as "idphoto.consent.v2", asked again once after the merge). */
export const PHOTO_CONSENT =
  "Tôi đồng ý để hệ thống xử lý ảnh khuôn mặt của tôi để làm ảnh thẻ và chỉnh ảnh. Ảnh tự xoá sau 24 giờ và không dùng " +
  "để huấn luyện AI.";

/** v4 "Chỉnh ảnh" (web/src/editor): labels of the panels; op labels come from the catalogue (edit_ops.json). */
export const EDIT = {
  pageTitle: "Chỉnh ảnh",
  nav: { idphoto: "Ảnh thẻ", edit: "Ảnh chuyên nghiệp", editShort: "Chỉnh ảnh" },   // short: phones (< 600 px)
  notForDocuments: "Ảnh đã chỉnh — không dùng cho giấy tờ (hộ chiếu, CCCD, visa). Làm ảnh thẻ ở chế độ Ảnh thẻ.",
  photoSection: "Ảnh",
  pickHint: "JPG, PNG hoặc WebP. Ảnh chân dung, cưới, kỷ yếu, gia đình…",
  uploading: "Đang gửi bản xem trước lên máy chủ…",
  needPhoto: "Chọn ảnh ở mục 1.",
  needConsent: "Đánh dấu ô đồng ý xử lý ảnh ở mục 1.",
  exportLabel: (cost: number) => (cost ? `Xuất ảnh · −${cost} token` : "Xuất ảnh · miễn phí"),
  exporting: "Đang gửi ảnh…",
  exported: (cost: number, total: number) => (cost ? `Đã trừ ${cost} token · còn ${total} token` : "Đã gửi ảnh"),
  download: (fmt: string) => `Tải ảnh (${fmt})`,
  resultTitle: "Ảnh đã xuất",
  before: "Trước",
  after: "Sau",
  holdBefore: "Giữ để xem ảnh gốc",
  zoom: {
    group: "Phóng to ảnh xem trước", in: "Phóng to", out: "Thu nhỏ", fit: "Vừa khung",
    hint: "lăn chuột / chụm hai ngón để phóng, kéo để di chuyển, nhấp đúp để phóng 2× hoặc về vừa khung",
    layersLocked: "Đang phóng to: kéo để di chuyển ảnh. Bấm % để về vừa khung rồi mới kéo được chữ, khung.",
  },
  /** "Làm đẹp nhanh" (2026-10-29): light n + beauty n levels from the catalogue, all rendered in one job */
  quick: {
    title: "Làm đẹp nhanh",
    intro: "Chọn một mức: ánh sáng và làm đẹp da đi đôi, từ tự nhiên tới kiểu studio. Xem trước miễn phí, chỉnh tiếp "
      + "bằng các mục bên dưới. Một lần chọn = một bước hoàn tác.",
    none: "Không dùng",
    noneHint: "Trả ánh sáng và da về mặc định.",
    render: (cost: number) => (cost ? `Render cả 4 mức · −${cost} token` : "Render cả 4 mức · miễn phí"),
    renderHint: "Máy xử lý làm cả 4 mức với các chỉnh sửa khác đang có, mỗi mức một ảnh đầy đủ JPG để so và tải.",
    busy: "Đang gửi ảnh…",
    sent: (cost: number, total: number) => (cost ? `Đã trừ ${cost} token · còn ${total} token` : "Đã gửi ảnh"),
    resultTitle: "4 mức làm đẹp",
    resultIntro: "So bốn mức rồi tải mức ưng ý, hoặc dùng mức đó để chỉnh tiếp.",
    working: "Đang render",
    use: "Dùng mức này",
    using: "Đang chỉnh theo mức này",
    download: "Tải ảnh (JPG)",
    historyLabel: "4 mức làm đẹp",
    batchOff: "Render cả 4 mức làm từng ảnh một, không dùng khi đang chỉnh hàng loạt.",
  },
  /** v4 "Kích nét" (render_worker/sharpen.py): plain words only — no model names, no scores */
  sharpen: {
    title: "Kích nét ảnh",
    intro: "Ảnh hơi mờ, nhòe? Kích nét làm mắt, lông mày, tóc, vải áo rõ hơn mà khuôn mặt và vân da giữ nguyên, "
      + "không bị bệt như da nhựa. Ảnh nhỏ được phóng to gấp đôi để in đẹp. Làm trước khi chỉnh, rồi chỉnh trên ảnh đã kích nét.",
    button: (cost: number) => (cost ? `Kích nét ảnh · −${cost} token` : "Kích nét ảnh · miễn phí"),
    busy: "Đang gửi ảnh…",
    sent: (cost: number, total: number) => (cost ? `Đã trừ ${cost} token · còn ${total} token` : "Đã gửi ảnh để kích nét"),
    batchOff: "Kích nét làm từng ảnh một, không dùng khi đang chỉnh hàng loạt.",
    already: "Ảnh đang chỉnh là bản đã kích nét.",
    working: "Đang kích nét",
    reportTitle: "Báo cáo kích nét",
    reportIntro: "Xem kỹ trước khi dùng làm ảnh nguồn để chỉnh tiếp.",
    before: "Trước",
    after: "Sau kích nét",
    closeUp: "Cận khuôn mặt",
    whole: "Cả ảnh",
    sharpness: (gain: number) => (gain >= 1.25 ? "Độ nét: tăng rõ — mắt, tóc, đường nét sắc hơn."
      : gain >= 1.08 ? "Độ nét: tăng nhẹ." : "Độ nét: ảnh vốn đã khá nét nên thay đổi ít."),
    faceKept: "Khuôn mặt: giữ nguyên như ảnh gốc (đã đối chiếu).",
    faceNone: "Không thấy khuôn mặt để đối chiếu — hãy xem kỹ ảnh trước khi dùng.",
    skinKept: "Vân da: giữ như ảnh gốc, không bị bệt hay bóng nhựa.",
    skinAdded: "Vân da: ảnh gốc mờ nên đã thêm vân da mô phỏng nhẹ để da không bị bệt — xem kỹ ảnh cận mặt.",
    skinSmooth: "Vân da: ảnh gốc quá mờ, da sẽ mịn hơn thực tế.",
    size: (w0: number, h0: number, w1: number, h1: number) => (w1 > w0
      ? `Kích thước: ${w0} × ${h0} → ${w1} × ${h1} px (phóng to để in sắc nét).`
      : `Kích thước: giữ nguyên ${w1} × ${h1} px.`),
    use: "Dùng ảnh này để chỉnh tiếp",
    using: "Đang mở ảnh đã kích nét…",
    used: "Đang chỉnh trên ảnh đã kích nét; các chỉnh sửa đã làm vẫn giữ.",
    useFailed: "Không mở được ảnh đã kích nét. Hãy thử lại, hoặc tải ảnh về rồi chọn lại ở mục 1.",
    download: "Tải ảnh đã kích nét (JPG)",
    historyLabel: "Kích nét",
  },
  undo: "Hoàn tác",
  redo: "Làm lại",
  reset: "Đặt lại",
  resetHint: "Nhấp đúp để đặt lại",
  resetAll: "Đặt lại tất cả",
  previewApprox: "Đang xem gần đúng…",
  previewExact: "Xem trước khớp ảnh xuất",
  previewWaiting: "Đang cập nhật xem trước…",
  noWebgl: "Trình duyệt không hỗ trợ WebGL nên không xem trước được; ảnh xuất vẫn đúng các chỉnh sửa.",
  emptyViewer: "Chọn ảnh ở mục 1 để bắt đầu chỉnh.",
  params: {
    "white_balance.temperature": "Nhiệt độ màu", "white_balance.tint": "Tint (xanh ↔ hồng)",
    "levels.in_black": "Điểm đen vào", "levels.gamma": "Gamma", "levels.in_white": "Điểm trắng vào",
    "levels.out_black": "Đen ra", "levels.out_white": "Trắng ra",
    "sharpen.amount": "Độ nét", "sharpen.radius": "Bán kính", "sharpen.reduce_noise": "Bớt nhiễu khi kích nét",
    "noise_reduction.strength": "Giảm nhiễu sáng", "noise_reduction.preserve_details": "Giữ chi tiết",
    "noise_reduction.color_noise": "Giảm nhiễu màu",
    "vignette.amount": "Vignette", "vignette.midpoint": "Điểm giữa", "vignette.roundness": "Độ tròn",
    "vignette.feather": "Độ mềm",
  } as Record<string, string>,
  crop: {
    ratio: "Tỉ lệ khung",
    ratios: { free: "Tự do", original: "Như ảnh gốc", "2:3": "2 : 3", "3:4": "3 : 4", "4:6": "4 × 6",
              "10x15": "10 × 15 cm", "13x18": "13 × 18 cm", "1:1": "Vuông 1 : 1" } as Record<string, string>,
    zoom: "Phóng to", panX: "Dịch ngang", panY: "Dịch dọc", angle: "Làm thẳng (độ)",
    hint: "Khung cắt luôn nằm trong ảnh; góc nghiêng xoay ảnh quanh tâm khung.",
  },
  /** plan "tăng cường web" §7: editing directly on the picture (editor/direct/) */
  direct: {
    cropToggle: "Kéo khung trên ảnh",
    cropHint: "Kéo khung để dời, kéo góc / cạnh để đổi cỡ (tỉ lệ cố định thì giữ tỉ lệ); phím mũi tên dịch khung, "
      + "Shift để bước lớn. Bấm Xong để xem ảnh đã cắt.",
    cropSideHint: "Bên trái là cả ảnh với khung cắt, bên phải là ảnh sau khi cắt.",
    frame: "Khung cắt: kéo để dời, phím mũi tên để dịch",
    handles: { n: "cạnh trên", s: "cạnh dưới", e: "cạnh phải", w: "cạnh trái", ne: "góc trên phải", nw: "góc trên trái",
               se: "góc dưới phải", sw: "góc dưới trái" } as Record<string, string>,
    handle: (name: string) => `Kéo ${name} để đổi cỡ khung`,
    subjectToggle: "Kéo người trên ảnh",
    subjectHint: "Kéo người để dời; lăn chuột, chụm hai ngón hoặc kéo góc để đổi cỡ; phím mũi tên dịch, + / − đổi cỡ. "
      + "Khung chỉ là gợi ý, ảnh xem trước cập nhật khi thả tay.",
    subject: "Người trên phông mới: kéo để dời, phím mũi tên để dịch, + / − để đổi cỡ",
    subjectScale: "Kéo để đổi cỡ người",
    pick: "Chấm điểm xám",
    pickTitle: "Bấm rồi chấm vào chỗ đáng lẽ có màu xám hoặc trắng trong ảnh",
    pickHint: "Chấm vào chỗ đáng lẽ có màu xám hoặc trắng (tường, áo trắng, tờ giấy…) để cân bằng trắng · Esc để huỷ.",
    picker: "Chấm điểm xám trên ảnh",
    pickDark: "Chỗ vừa chấm quá tối để đo màu; hãy chấm vào chỗ xám hoặc trắng sáng hơn.",
    pickOutside: "Chỗ vừa chấm nằm ngoài ảnh; hãy chấm vào bên trong ảnh.",
    pickFailed: "Trình duyệt không đọc được màu của ảnh; hãy chỉnh bằng thanh trượt.",
    picked: "Đã cân bằng trắng theo điểm vừa chấm.",
    pickedClamped: "Điểm vừa chấm lệch màu nhiều nên chỉ chỉnh được tới giới hạn của thanh trượt.",
    done: "Xong",
    cancel: "Huỷ",
    warningsLabel: "Lưu ý về bản xem trước",
  },
  auto: { button: "Tự động", busy: "Đang đo ảnh…", on: "Đã áp dụng thông số tự động", strength: "Độ mạnh tự động" },
  lightProfiles: {
    title: "Kiểu ánh sáng có sẵn",
    hint: "Chọn kiểu gần với lúc chụp, rồi chỉnh tiếp bằng thanh trượt. Một lần chọn = một bước hoàn tác.",
    labels: {
      studio: "Studio sáng", soft: "Chân dung mềm", bright_clean: "Sáng trong", backlit: "Ngược sáng",
      dim: "Thiếu sáng", harsh_sun: "Nắng gắt", tungsten: "Đèn vàng trong nhà", overcast: "Trời râm",
      dramatic: "Tương phản mạnh",
    } as Record<string, string>,
    hints: {
      studio: "Ảnh chụp phông nền, đèn studio: sáng rõ, giữ chi tiết vùng sáng.",
      soft: "Chân dung dịu: giảm tương phản, mở vùng tối, da mềm hơn.",
      bright_clean: "Sáng, trong, nhẹ nhàng kiểu Hàn Quốc.",
      backlit: "Chụp ngược sáng: mặt tối, nền / trời cháy sáng.",
      dim: "Ảnh tối, thiếu sáng trong nhà hoặc buổi tối.",
      harsh_sun: "Nắng trưa gắt: bóng đổ đậm, vùng sáng cháy.",
      tungsten: "Đèn vàng / đèn sợi đốt trong nhà: ảnh ám vàng cam.",
      overcast: "Trời râm, bóng râm: ảnh xám, hơi lạnh.",
      dramatic: "Tương phản mạnh, khối rõ — hợp ảnh nghệ thuật, không hợp ảnh thẻ.",
    } as Record<string, string>,
  },
  curves: {
    channel: "Kênh", channels: { rgb: "RGB", red: "Đỏ", green: "Lục", blue: "Lam" } as Record<string, string>,
    aria: "Đường cong tone", hint: "Kéo điểm để chỉnh, nhấp vào đường để thêm điểm, nhấp đúp vào điểm để xoá.",
    levels: "Levels",
  },
  hsl: {
    mode: "Chỉnh theo", modes: { hue: "Màu sắc", saturation: "Bão hoà", luminance: "Độ sáng" } as Record<string, string>,
    colours: { red: "Đỏ", orange: "Cam", yellow: "Vàng", green: "Lục", aqua: "Lơ", blue: "Lam", purple: "Tím",
               magenta: "Hồng" } as Record<string, string>,
  },
  grading: {
    ranges: { shadows: "Vùng tối", midtones: "Trung tính", highlights: "Vùng sáng" } as Record<string, string>,
    hue: "Màu", sat: "Độ đậm", lum: "Độ sáng", blending: "Hoà trộn", balance: "Cân bằng",
  },
  detail: {
    sharpen: "Kích nét", noise: "Giảm nhiễu", vignette: "Vignette",
    hint: "Các mục này hiện chính xác sau khi máy xử lý dựng bản xem trước (dưới 1 giây sau khi thả tay).",
  },
  preset: {
    aria: "Chọn preset", off: "Không dùng", strength: "Độ mạnh preset", loading: "Đang tải preset…",
    none: "Chưa có preset nào trong thư viện.",
  },
  export: {
    format: "Định dạng", formats: { jpg: "JPG", png: "PNG", tif: "TIFF" } as Record<string, string>,
    size: "Kích thước", sizes: { original: "Như ảnh gốc", long_edge: "Theo cạnh dài", print: "Theo khổ in" } as Record<string, string>,
    longEdge: "Cạnh dài (px)", widthMm: "Rộng (mm)", heightMm: "Cao (mm)", dpi: "Độ phân giải (dpi)",
    quality: "Chất lượng JPG", printHint: "Ảnh không bị kéo méo: chọn tỉ lệ khung ở mục Cắt & xoay cho đúng khổ in.",
  },
  // GĐ2 "Da", "Trang điểm", "Khuôn mặt", "Đánh khối" (docs/V4_CHINH_ANH_GD2.md); op labels come from the catalogue
  retouch: {
    hint: "Áp cho khuôn mặt chính trong ảnh. Mục nào làm khuôn mặt khác đi quá nhiều sẽ tự tắt và được báo dưới ảnh.",
    smooth: "Mịn da", smoothModes: { off: "Tắt", light: "Nhẹ", medium: "Vừa", custom: "Tuỳ chỉnh" } as Record<string, string>,
    smoothStrength: "Độ mịn", redEye: "Mắt đỏ", colour: "Màu",
    colours: {
      red: "Đỏ", pink: "Hồng", coral: "San hô", nude: "Nude", plum: "Mận", rose: "Hồng đất", brown: "Nâu",
      peach: "Đào", smoky: "Khói", gold: "Ánh vàng",
    } as Record<string, string>,
    dodge: "Sáng khối (dodge)", burn: "Tối khối (burn)",
    contourHint: "Chỉ làm sáng / tối từng vùng theo điểm mốc khuôn mặt, không đổi hình dạng.",
    shapeBadge: "Đổi hình dạng",
    shapeAlert: GEOMETRY_ALERT,                       // the same sentence in both modes
    shapeHint: "Các mục dưới đây đổi hình dạng khuôn mặt: chỉ cho ảnh kỷ niệm, mạng xã hội.",
    shapeNotes: {
      eye_enlarge: "Phóng vùng mắt tối đa 10 %.", face_slim: "Thu gọn hàm và má dưới.",
      v_line: "Thon hàm dưới, cằm gọn và dài hơn một chút.", nose_slim: "Thu gọn hai cánh mũi.",
      mouth_small: "Thu gọn hai khoé miệng.", brow_lift: "Nâng lông mày lên một chút.",
      lip_full: "Viền môi dày thêm một chút.", feature_balance: "Làm đều lông mày, mắt, mũi, khoé miệng hai bên.",
    } as Record<string, string>,
    reset: "Tắt hết",
    warnings: {
      face_not_found: "Không thấy khuôn mặt trong ảnh (sau khi cắt) nên các mục chỉnh da, trang điểm, khuôn mặt chưa được áp dụng.",
      face_landmarks_missing: "Chưa nhận diện đủ nét mặt nên các mục chỉnh da, trang điểm, khuôn mặt chưa được áp dụng.",
      face_too_small: "Khuôn mặt quá nhỏ trong ảnh nên các mục chỉnh da, trang điểm, khuôn mặt chưa được áp dụng.",
      face_check_unavailable: "Máy xử lý chưa kiểm được độ giống khuôn mặt nên các mục chỉnh mặt chưa được áp dụng.",
      geometry_edit_not_for_documents: "Có chỉnh hình dạng khuôn mặt: KHÔNG dùng ảnh này cho hộ chiếu, CCCD, visa.",
      // not a face code, but shown the same way (render_worker/edit/run.py): PSD keeps layers, GĐ5 works on the flat picture
      finish_not_for_psd: "File PSD giữ nguyên các lớp nên không đóng logo và không xếp tờ in; xuất JPG / PNG / TIFF để có logo và tờ in.",
    } as Record<string, string>,
    dropped: (label: string) => `Đã tự tắt «${label}» vì làm khuôn mặt khác đi quá nhiều.`,
  },
  // ---- v4 GĐ5 "Hàng loạt & in" ----
  batch: {
    pickHint: "Chọn nhiều ảnh cùng lúc để áp cùng một công thức cho tất cả (tối đa 50 ảnh).",
    title: (n: number) => `Hàng loạt · ${n} ảnh`,
    editing: (i: number) => `Đang chỉnh trên ảnh ${i}; công thức áp cho mọi ảnh.`,
    select: (name: string) => `Chỉnh trên ảnh ${name}`,
    remove: (name: string) => `Bỏ ảnh ${name}`,
    add: "Thêm ảnh",
    clear: "Bỏ hàng loạt",
    max: (n: number) => `Tối đa ${n} ảnh mỗi lần; đã bỏ bớt các ảnh sau.`,
    exportLabel: (n: number, cost: number) => (cost ? `Xuất ${n} ảnh · −${cost} token` : `Xuất ${n} ảnh · miễn phí`),
    perPhoto: (cost: number) => (cost ? `${cost} token mỗi ảnh; ảnh lỗi được hoàn token.` : "Tài khoản thử nghiệm · không trừ token"),
    adaptHint: "Khung cắt theo tỉ lệ được đặt lại trên từng ảnh; “Tự động” đo lại từng ảnh.",
    preparing: (i: number, n: number) => `Đang chuẩn bị ảnh ${i}/${n}…`,
    uploading: (i: number, n: number) => `Đang tải ảnh ${i}/${n} lên…`,
    starting: "Đang bắt đầu xử lý…",
    started: (n: number, cost: number, total: number) =>
      (cost ? `Đã trừ ${cost} token cho ${n} ảnh · còn ${total} token` : `Đã gửi ${n} ảnh`),
    replayed: "Lô ảnh này đã được gửi trước đó, không trừ thêm token.",
    resultTitle: "Kết quả hàng loạt",
    progress: (done: number, n: number) => `Xong ${done}/${n} ảnh`,
    failed: (n: number, refunded: number) => `${n} ảnh không xử lý được · đã hoàn ${refunded} token`,
    waiting: (n: number) => `${n} ảnh đang chờ / đang xử lý`,
    zip: (n: number) => `Tải tất cả (ZIP, ${n} ảnh)`,
    zipHint: "ZIP gồm ảnh đã xuất, tờ in (nếu có) và ket-qua.csv ghi trạng thái từng ảnh.",
    cancel: "Huỷ các ảnh đang chờ",
    cancelled: "Đã huỷ các ảnh chưa xử lý và hoàn token.",
    uploaded: "Đã tải lên",
    statusOf: { uploaded: "Đã tải", queued: "Đang chờ", running: "Đang xử lý", done: "Xong", rejected: "Lỗi",
                failed: "Lỗi", cancelled: "Đã huỷ" } as Record<string, string>,
    refundedOne: "đã hoàn token",
    downloadOne: "Tải ảnh",
    sheetTitle: "Gộp tờ in chung",
    sheetHint: "Xếp mọi ảnh đã xong lên tờ in theo thiết lập ở mục “Xếp tờ in” (mỗi ảnh một lần).",
    sheetButton: (cost: number) => (cost ? `Xếp tờ in chung · −${cost} token` : "Xếp tờ in chung · miễn phí"),
    sheetBusy: "Đang xếp tờ in…",
    sheetReady: "Tờ in chung",
  },
  sheet: {
    enabled: "Xuất kèm tờ in (PDF + JPG 300 dpi)",
    paper: "Khổ giấy",
    orientation: "Hướng giấy",
    orientations: { portrait: "Dọc", landscape: "Ngang" } as Record<string, string>,
    layout: "Cách xếp",
    layouts: { fill: "Một ảnh cả tờ", grid: "Nhiều ảnh theo cỡ" } as Record<string, string>,
    size: "Cỡ ảnh trên tờ",
    sizes: { "30x40": "3 × 4 cm", "40x60": "4 × 6 cm", "90x120": "9 × 12 cm", "100x150": "10 × 15 cm",
             "130x180": "13 × 18 cm", "150x210": "15 × 21 cm", "200x300": "20 × 30 cm", custom: "Tuỳ chỉnh" } as Record<string, string>,
    widthMm: "Rộng (mm)", heightMm: "Cao (mm)",
    copies: "Số ảnh trên tờ", copiesHint: (max: number) => `0 = xếp đầy tờ (tối đa ${max} ảnh/tờ)`,
    margin: "Lề giấy (mm)", gap: "Khoảng cách giữa ảnh (mm)",
    cutMarks: "Vạch cắt ở góc ảnh", rotate: "Tự xoay ảnh cho vừa ô",
    preview: (n: number, paper: string) => `Xem trước: ${n} ảnh trên ${paper}`,
    tooBig: "Cỡ ảnh lớn hơn vùng in của khổ giấy này.",
    hint: "In đúng cỡ (100 %, không chọn “Vừa trang / Fit to page”), rồi cắt theo vạch. Tờ in tính chung 1 lần xuất.",
    download: "Tải tờ in (PDF)", downloadJpg: "Tải tờ in (JPG)",
  },
  logo: {
    studioOnly: "Dành cho tài khoản tiệm ảnh.",
    none: "Không đóng logo",
    upload: "Tải logo lên (PNG nền trong suốt)",
    uploading: "Đang tải logo…",
    empty: "Chưa có logo. Tải lên file PNG có nền trong suốt.",
    remove: (name: string) => `Xoá logo ${name}`,
    confirmRemove: (name: string) => `Xoá logo “${name}”? Ảnh đã xuất không bị ảnh hưởng.`,
    count: (n: number, max: number) => `${n}/${max} logo · chỉ tài khoản của bạn thấy và dùng được`,
    aria: "Chọn logo",
    anchor: "Vị trí",
    anchors: { top_left: "Trên trái", top: "Trên giữa", top_right: "Trên phải", left: "Giữa trái", center: "Chính giữa",
               right: "Giữa phải", bottom_left: "Dưới trái", bottom: "Dưới giữa", bottom_right: "Dưới phải" } as Record<string, string>,
    size: "Cỡ logo (% bề rộng ảnh)", margin: "Cách mép (% bề rộng)", opacity: "Độ đậm",
    tile: "Lặp kín ảnh (chống sao chép)", tileGap: "Khoảng cách lặp",
    preview: "Xem trước vị trí logo",
    hint: "Logo được đóng lên ảnh xuất ở đúng kích thước cuối, cả khi xuất hàng loạt và trên tờ in.",
  },
  // GĐ4: chữ, khung, overlay (web/src/editor/layers, panels/LayersPanel.tsx)
  layers: {
    title: "Chữ, khung & overlay",
    tabs: { text: "Chữ", text_template: "Mẫu chữ", frame: "Khung", overlay: "Overlay" } as Record<string, string>,
    addText: "Thêm chữ",
    newText: "Chữ của bạn",
    list: "Các lớp (trên cùng ở đầu)",
    empty: "Chưa có lớp nào: thêm chữ, mẫu chữ, khung hoặc overlay.",
    loading: "Đang tải thư viện…",
    none: "Chưa có mục nào trong thư viện.",
    maxReached: "Đã đủ số lớp tối đa cho loại này.",
    pickHint: "Chạm vào một mục để thêm lên ảnh. Kéo lớp trên ảnh để di chuyển, kéo góc để phóng to, kéo núm tròn để xoay.",
    select: "Chọn lớp", show: "Hiện lớp", hide: "Ẩn lớp", up: "Đưa lên trên", down: "Đưa xuống dưới",
    duplicate: "Nhân bản", remove: "Xoá", copy: "Sao chép", paste: "Dán", invert: "Đảo màu", flipX: "Lật ngang",
    flipY: "Lật dọc", rotate90: "Xoay 90°", centre: "Về giữa", shadow: "Đổ bóng", recolor: "Đổi màu", style: "Kiểu chữ",
    styles: { "white-outline": "Trắng viền đen", gold: "Vàng đổ bóng", dark: "Đen", pink: "Hồng viền trắng" } as Record<string, string>,
    noRecolor: "Không đổi màu",
    text: "Nội dung", font: "Font", size: "Cỡ chữ", color: "Màu chữ", align: "Căn lề",
    aligns: { left: "Trái", center: "Giữa", right: "Phải" } as Record<string, string>,
    lineHeight: "Giãn dòng", tracking: "Giãn chữ", stroke: "Viền chữ", strokeColor: "Màu viền", shadowOpacity: "Đổ bóng",
    shadowColor: "Màu bóng", shadowX: "Bóng ngang", shadowY: "Bóng dọc", shadowBlur: "Độ nhoè bóng",
    opacity: "Độ đậm lớp", blend: "Hoà trộn",
    blends: { normal: "Bình thường", multiply: "Nhân (multiply)", screen: "Sáng (screen)", overlay: "Overlay",
              soft_light: "Ánh sáng dịu (soft light)" } as Record<string, string>,
    rotation: "Xoay (độ)", width: "Độ rộng", scaleLabel: "Kích thước", fields: "Nội dung mẫu",
    fieldHint: "Để trống một dòng để ẩn dòng đó.", templateColor: "Đổi màu chữ của mẫu",
    handles: "Lớp đang chọn: kéo để di chuyển, phím mũi tên để dịch, Delete để xoá", scale: "Kéo để phóng to / thu nhỏ",
    stretch: "Kéo để giãn", rotate: "Kéo để xoay (giữ Shift: mỗi nấc 15°)",
    locked: (tier: string) => `Gói ${tier === "gold" ? "Gold" : "Plus"}: xem trước được, xuất ảnh cần nâng gói`,
    lockedNote: "Lớp có biểu tượng khoá chỉ xuất được với gói Plus / Gold.",
    merged: "Xuất JPG / PNG / TIFF gộp mọi lớp vào ảnh; xuất PSD giữ nguyên từng lớp (gói Plus / Gold).",
    psd: "PSD (giữ lớp)", psdLocked: "Xuất PSD (giữ từng lớp) dành cho gói Plus / Gold.",
    kinds: { text: "Chữ", text_template: "Mẫu chữ", frame: "Khung", overlay: "Overlay" } as Record<string, string>,
  },
  // ---- GĐ3: Phông nền, Bầu trời, AI, Dáng người, Phục chế ----
  library: { loading: "Đang tải thư viện…", none: "Chưa có mục nào trong thư viện.", off: "Không dùng" },
  background: {
    aria: "Chọn phông nền", x: "Dịch ngang", y: "Dịch dọc", scale: "Cỡ người", shadow: "Bóng đổ",
    harmonize: "Hoà màu, ánh sáng",
    colour: "Nền màu", library: "Phông từ thư viện",
    hint: "Người được tách bằng AI của DTAA rồi ghép lên nền màu hoặc phông. Ảnh toàn thân trên phông: người đứng trên sàn của phông; ảnh nửa người và nền màu giữ nguyên vị trí.",
  },
  sky: {
    aria: "Chọn bầu trời", strength: "Độ mạnh", harmonize: "Hoà màu cảnh vật",
    hint: "Dành cho ảnh chụp ngoài trời. Ảnh trong nhà có tường hoặc phông trắng có thể bị nhận nhầm là trời.",
  },
  ai: {
    notPreviewed: "Các bước AI chỉ xem được sau khi xử lý (mỗi lần khoảng 1–2 phút).",
    price: (cost: number) => (cost ? `${cost} token` : "miễn phí"),
    iron: "Ủi đồ", ironHint: "Làm phẳng nếp nhăn quần áo; khuôn mặt giữ nguyên.",
    outfit: "Thay áo", outfitGroup: "Nhóm", outfitKeep: "Giữ nguyên",
    outfitHint: "Khuôn mặt gốc được giữ nguyên. Áo được thay tới mép dưới ảnh; ảnh toàn thân chỉ thay tới khoảng đầu gối.",
    smile: "Miệng cười",
    smileHint: "AI vẽ lại nét mặt — luôn kiểm tra trước khi in. Chỉ cho ảnh chân dung, không dùng cho ảnh giấy tờ.",
    templeNote: "Trang phục đi lễ chùa của Phật tử tại gia. Xin dùng trang nghiêm; không dùng để giả danh tu sĩ hay tổ chức tôn giáo.",
    model: "Model", standard: (cost: number) => `Tiêu chuẩn (${cost} token)`,
    topupOnly: "Model cao cấp chỉ trừ token nạp.",
    on: "Đã bật", turnOn: "Bật", turnOff: "Tắt",
    exportNote: (cost: number) => `Có bước AI: xuất ảnh trừ ${cost} token, chờ khoảng 1–2 phút.`,
  },
  /** v4 editor-only outfits (genai.tasks.EDITOR_OUTFITS); the 29 others come from catalog.json */
  outfits: {
    vay_nu: "Váy nữ", ao_ba_ba: "Áo bà ba", quan_bo: "Quần bò (jeans)", ao_visa: "Áo visa (sơ mi tối màu)",
    khan_xep: "Khăn xếp + áo dài", day_chuyen: "Dây chuyền vàng mảnh", ao_trang_di_chua: "Áo tràng đi lễ chùa",
  } as Record<string, string>,
  outfitGroupOther: "Khác",
  body: {
    badge: "Thay đổi dáng người — không dùng cho giấy tờ", waist: "Eo, thân", arms: "Bắp tay",
    hint: "Khuôn mặt không bị kéo; độ dịch tối đa 5 % bề ngang vai. Hợp với ảnh một người đứng / ngồi thẳng.",
  },
  restore: {
    dust: "Bụi, đốm", scratches: "Vết xước", fade: "Màu bạc",
    hint: "Xoá bụi, vết xước và phục hồi màu trên chính điểm ảnh của bạn — không dùng AI vẽ lại khuôn mặt (giữ nốt ruồi).",
  },
  /** job / preview warning codes (render machine) → what the page says; unknown codes are not shown */
  warnings: {
    edit_ai_expression: "Nét mặt do AI vẽ lại — kiểm tra kỹ trước khi in.",
    edit_ai_applied: "Đã chỉnh bằng AI; khuôn mặt đã được kiểm tra giống ảnh gốc.",
    edit_body_reshaped: "Dáng người đã được làm thon — không dùng cho giấy tờ.",
    sky_not_found: "Không tìm thấy bầu trời trong ảnh nên giữ nguyên.",
    background_no_person: "Không tách được người nên giữ phông gốc.",
    body_not_found: "Không thấy rõ vai, dáng người nên không làm thon.",
    matte_degraded: "Tách người ở chế độ dự phòng: viền có thể chưa đẹp.",
    ai_not_previewed: "Các bước AI chỉ xem được sau khi xử lý.",
    print_size_low_res: "Có khổ in lớn hơn độ nét của ảnh (dưới 150 dpi): bản in có thể bị mờ.",
    print_size_dpi_capped: "Khổ in rất lớn nên máy xử lý hạ dpi của khổ đó để file không quá nặng.",
  } as Record<string, string>,
  // ---- merged page GĐ3 "Khổ in" (op print_size) ----
  sizes: {
    intro: "Mỗi khổ ra một file đúng kích thước in (JPG, dpi theo mục Xuất ảnh) để đưa tiệm in / lab. Khổ đầu tính trong lần xuất, mỗi khổ thêm 1 token.",
    add: "+ Thêm khổ in",
    max: (n: number) => `Tối đa ${n} khổ mỗi lần xuất.`,
    row: (i: number) => `Khổ ${i}`,
    paper: "Khổ",
    custom: "Tuỳ chỉnh (mm)",
    widthMm: "Rộng (mm)",
    heightMm: "Cao (mm)",
    orientation: "Hướng",
    orientations: { portrait: "Dọc", landscape: "Ngang" } as Record<string, string>,
    copies: "Số tấm",
    fit: "Vừa khổ",
    fits: { fill: "Cắt cho đầy khổ", border: "Giữ nguyên ảnh, thêm viền" } as Record<string, string>,
    border: "Viền (mm)",
    borderColor: "Màu viền",
    zoom: "Phóng khung",
    panX: "Khung ngang",
    panY: "Khung dọc",
    remove: "Bỏ khổ này",
    preview: (label: string) => `Khung in ${label} trên ảnh`,
    sharp: {
      good: (dpi: number) => `Độ nét ${dpi} dpi · tốt`,
      ok: (dpi: number) => `Độ nét ${dpi} dpi · dùng được`,
      low: (dpi: number) => `Độ nét ${dpi} dpi · ảnh không đủ nét cho khổ này: thử Kích nét ở mục 1 hoặc chọn khổ nhỏ hơn`,
    },
    price: (n: number) => (n <= 1 ? "Khổ đầu tiên tính trong lần xuất." : `${n} khổ: thêm ${n - 1} token so với xuất một file.`),
    aside: (n: number) => `${n} khổ`,
    resultTitle: "Các khổ in",
    line: (label: string, copies: number, px: string, dpi: number) => `${label} · ${copies} tấm · ${px} px · ${dpi} dpi`,
    download: "Tải",
    zip: "Tải tất cả khổ in (ZIP + phiếu in)",
  },
};

/**
 * GĐ2: the face-step warnings of an editor preview or export (render machine codes) as sentences; other codes
 * (edit_not_for_documents: shown on its own; auto_without_face, nsfw_review) are left out. `labelOf` = op label.
 */
export function editWarnings(warnings: string[] | undefined, labelOf: (op: string) => string): string[] {
  const out = (warnings ?? []).flatMap((w) => {
    if (w.startsWith("face_step_dropped:")) return [EDIT.retouch.dropped(labelOf(w.slice("face_step_dropped:".length)))];
    const sentence = EDIT.retouch.warnings[w];
    return sentence ? [sentence] : [];
  });
  return [...new Set(out)];
}

/** "dưới 1 phút" / "khoảng 3 phút". */
function aboutMinutes(seconds: number): string {
  return seconds < 60 ? "dưới 1 phút" : `khoảng ${Math.ceil(seconds / 60)} phút`;
}

/** v4: is a render machine on, where a waiting photo stands (server availability.py, web/src/queues.ts). */
export const QUEUE = {
  aiPaused: "AI tạm nghỉ, chưa nhận ảnh AI",
  asidePaused: "AI tạm nghỉ",
  aiPausedHint: "Máy xử lý AI đang nghỉ nên tạm chưa nhận ảnh có chỉnh sửa AI; trang tự kiểm tra lại mỗi 30 giây.",
  /** ID photos: the render button's reason (no token taken) */
  aiPausedRender: "AI tạm nghỉ, chưa nhận ảnh AI: tắt chỉnh sửa nâng cao ở mục 5 để xử lý ngay, hoặc thử lại sau ít phút.",
  /** the editor: the export button's reason */
  aiPausedExport: "AI tạm nghỉ, chưa nhận ảnh AI: bỏ các bước AI (ủi đồ, thay áo, miệng cười) để xuất ngay, hoặc thử lại sau ít phút.",
  idle: "Máy xử lý đang nghỉ, ảnh sẽ chờ tối đa 10 phút (quá thời gian thì tự huỷ và hoàn token).",
  /** "Còn 3 ảnh trước bạn, khoảng 2 phút" */
  wait: (position: number, eta: number | null | undefined) =>
    `${position > 0 ? `Còn ${position} ảnh trước bạn` : "Ảnh của bạn được xử lý tiếp theo"}${eta != null ? `, ${aboutMinutes(eta)}` : ""}`,
  batchWait: (position: number, eta: number | null | undefined) =>
    `${position > 0 ? `Còn ${position} ảnh trước lô này` : "Lô này được xử lý tiếp theo"}${eta != null ? `, ${aboutMinutes(eta)} nữa xong cả lô` : ""}`,
};

/** v4 "Giới thiệu bạn bè" (account menu → dialog, components/ReferralDialog.tsx; server referrals.py). */
export const REFERRAL = {
  menu: "Giới thiệu bạn bè",
  title: "Giới thiệu bạn bè",
  intro: (reward: number) =>
    `Gửi link này cho bạn bè. Khi bạn của bạn đăng nhập lần đầu bằng link và có ảnh đầu tiên xử lý xong, cả hai cùng nhận ${reward} token vào ví quảng cáo.`,
  rules: (perMonth: number, cap: number) =>
    `Tối đa ${perMonth} lần thưởng mỗi tháng; ví quảng cáo chứa tối đa ${cap} token. Token không có giá trị tiền.`,
  linkLabel: "Link giới thiệu của bạn",
  copy: "Sao chép",
  copied: "Đã sao chép link.",
  copyFailed: "Không sao chép được: hãy chọn link rồi sao chép.",
  share: "Chia sẻ",
  shareTitle: "DTAA Ảnh Thẻ",
  shareText: "Làm ảnh thẻ đúng chuẩn và chỉnh ảnh online, mỗi ngày có token miễn phí:",
  invited: "Bạn đã mời",
  rewarded: "Đã nhận thưởng",
  tokens: "Token đã nhận",
  thisMonth: (n: number, max: number) => `Tháng này: ${n} / ${max} lần thưởng.`,
  loading: "Đang tải…",
  off: "Chương trình giới thiệu đang tạm dừng.",
  close: "Đóng",
};

/** "Chia sẻ" on a finished photo (components/ShareResult.tsx): the file itself through the phone's share sheet. */
export const SHARE_RESULT = {
  button: "Chia sẻ",
  busy: "Đang chuẩn bị…",
  failed: "Không chia sẻ được ảnh. Hãy tải ảnh về rồi gửi.",
  title: "Ảnh từ DTAA",
};
